import { render, staticRenderFns } from "./SeriesPage.vue?vue&type=template&id=5198c1f4&scoped=true&"
import script from "./SeriesPage.vue?vue&type=script&lang=js&"
export * from "./SeriesPage.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPage.vue?vue&type=style&index=0&id=5198c1f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5198c1f4",
  null
  
)

export default component.exports